const ID_TOKEN_KEY = "id_token" as string;
const ID_REFRESH_KEY = "refresh_token" as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

/**
 * @description get refresh token form localStorage
 */
export const getRefresh = (): string | null => {
  return window.localStorage.getItem(ID_REFRESH_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveRefresh = (token: string): void => {
  window.localStorage.setItem(ID_REFRESH_KEY, token);
};

/**
 * @description remove refresh token form localStorage
 */
export const destroyRefresh = (): void => {
  window.localStorage.removeItem(ID_REFRESH_KEY);
};

export default { getToken, saveToken, destroyToken, getRefresh, saveRefresh, destroyRefresh };
